// Header text for the selected businesses: none/All -> 'All Businesses';
// one -> its name; several -> first names joined, then '+N more'.
// full is the complete list for the tooltip.
export function selectedBusinessesText(ids, locations, shown = 2) {
  const names = (ids || [])
    .map((id) => (locations.find((b) => Number(b.id) === Number(id)) || {}).name)
    .filter(Boolean);
  if (names.length === 0) return { text: 'All Businesses', full: 'All Businesses' };
  const full = names.join(', ');
  if (names.length <= shown) return { text: full, full };
  return { text: `${names.slice(0, shown).join(', ')} +${names.length - shown} more`, full };
}
